@if (small) {
    <svg class="size-4">
        <image [attr.xlink:href]="iconUrl" width="16" height="16" [attr.class]="filterClass"/>
    </svg>
} @else {
    <svg class="size-6">
        <image [attr.xlink:href]="iconUrl" width="24" height="24" [attr.class]="filterClass"/>
    </svg>
}